import React from "react";
import { useLanguage } from "./LanguageProvider";

const Header = () => {

    const { changeLanguage} = useLanguage();

    return (
        <header style={styles.header}>
            <div style={styles.logoContainer}>
                <img src="/logo_full.jpg" alt="Logo" style={styles.logo} />
            </div>
            <div style={styles.languageSwitcher}>
                <button
                    style={styles.languageButton}
                    onClick={() => changeLanguage("nl")}
                >
                    nl
                </button>
                <button
                    style={styles.languageButton}
                    onClick={() => changeLanguage("en")}
                >
                    en
                </button>
                <button
                    style={styles.languageButton}
                    onClick={() => changeLanguage("ru")}
                >
                    ru
                </button>
            </div>
        </header>
    );
};

const styles = {
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 20px",
        backgroundColor: "#f4f4f9",
        borderBottom: "2px solid #ddd",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    },
    logoContainer: {
        display: "flex",
        alignItems: "center",
    },
    logo: {
        height: "40px",
        cursor: "pointer",
    },
    languageSwitcher: {
        display: "flex",
        gap: "10px",
    },
    languageButton: {
        padding: "8px 12px",
        fontSize: "14px",
        fontWeight: "bold",
        color: "#007BFF",
        backgroundColor: "transparent",
        border: "1px solid #007BFF",
        borderRadius: "4px",
        cursor: "pointer",
        transition: "background-color 0.3s, color 0.3s",
    },
    languageButtonHover: {
        backgroundColor: "#007BFF",
        color: "#fff",
    },
};

export default Header;
